/* =========================================================
   Apparitions au scroll — ParfumShop38
   - N'active le masquage que si le JS tourne (classe .ps-js)
   - Observer conservé en référence (évite qu'il soit collecté)
   - Ce qui est déjà visible à l'ouverture apparaît tout de suite
   - Filet de sécurité : tout devient visible au bout de 4 s
   ========================================================= */
(function () {
  var root = document.documentElement;
  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  root.classList.add('ps-js');

  if (reduced) return;

  var observer = null;
  var failsafeTimer = null;

  var SKIP = ['header', 'footer', 'cart-drawer', 'announcement', 'auto-gifts', 'wishlist'];

  function shouldSkip(id) {
    for (var i = 0; i < SKIP.length; i++) {
      if (id.indexOf(SKIP[i]) !== -1) return true;
    }
    return false;
  }

  function reveal(el) {
    el.classList.add('is-revealed');
  }

  function markSections(scope) {
    var sections = (scope || document).querySelectorAll('.shopify-section');
    Array.prototype.forEach.call(sections, function (section) {
      if (shouldSkip(section.id || '')) return;
      if (section.hasAttribute('data-scroll-reveal')) return;
      if (section.hasAttribute('data-no-reveal')) return;
      section.setAttribute('data-scroll-reveal', '');
    });
  }

  function ensureObserver() {
    if (observer || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          if (observer) observer.unobserve(entry.target);
        });
      },
      { threshold: 0.06, rootMargin: '0px 0px -60px 0px' }
    );
  }

  function collect(scope) {
    var base = scope || document;
    var list = [];
    Array.prototype.push.apply(
      list,
      base.querySelectorAll('[data-scroll-reveal]:not(.is-revealed)')
    );
    Array.prototype.push.apply(
      list,
      base.querySelectorAll('[data-reveal-children]:not(.is-revealed)')
    );
    return list;
  }

  function init(scope) {
    markSections(scope);
    var targets = collect(scope);
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(reveal);
      return;
    }

    ensureObserver();

    var vh = window.innerHeight || 800;
    targets.forEach(function (el) {
      // Déjà visible au chargement : on affiche sans attendre le scroll
      var rect = el.getBoundingClientRect();
      if (rect.top < vh * 0.9 && rect.bottom > 0) {
        reveal(el);
        return;
      }
      observer.observe(el);
    });
  }

  function armFailsafe() {
    if (failsafeTimer) clearTimeout(failsafeTimer);
    failsafeTimer = setTimeout(function () {
      // Si des éléments sont restés masqués (onglet en arrière-plan,
      // transitions gelées, erreur JS ailleurs), on force l'affichage.
      var stuck = document.querySelectorAll(
        '[data-scroll-reveal]:not(.is-revealed), [data-reveal-children]:not(.is-revealed)'
      );
      if (!stuck.length) return;
      var vh = window.innerHeight || 800;
      Array.prototype.forEach.call(stuck, function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < vh && rect.bottom > 0) reveal(el);
      });
    }, 4000);
  }

  function boot() {
    init(document);
    armFailsafe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Onglet ré-affiché : Chrome gèle les transitions des onglets cachés
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') init(document);
  });

  // Éditeur de thème / sections chargées dynamiquement
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });

  window.addEventListener('load', function () {
    init(document);
  });
})();
